import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId } from "./SmoothScroll";

const LINKS = [["videos", "Videos"], ["stream", "Stream"], ["music", "Music"], ["label", "Label"], ["contact", "Contact"]];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => { setOpen(false); scrollToId(id); };
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 1.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-x-0 top-0 z-50 px-4 pt-4 sm:px-8"
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between rounded-full border border-[var(--line)] bg-[rgba(7,7,7,0.6)] py-2 pl-2 pr-3 backdrop-blur-xl">
        <button data-testid="nav-logo" onClick={() => go("top")} className="flex items-center gap-3">
          <img src="/mae-logo-ink.webp" alt="Money Alwayz Entertainment logo" className="h-10 w-10 rounded-full" />
          <span className="font-display text-lg uppercase tracking-wide">MAE</span>
        </button>
        <div className="hidden items-center gap-1 md:flex">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-${id}`} onClick={() => go(id)}
              className="rounded-full px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] text-zinc-300 transition-colors hover:bg-[var(--bone)] hover:text-[var(--ink)]">
              {label}
            </button>
          ))}
        </div>
        <button data-testid="nav-cta" onClick={() => go("stream")}
          className="hidden rounded-full bg-[var(--cash)] px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-[0.2em] text-[var(--ink)] transition-transform hover:scale-105 md:block">
          Stream now
        </button>
        <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="p-2 md:hidden" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>
      {open && (
        <div data-testid="nav-mobile-menu" className="mx-auto mt-2 flex max-w-7xl flex-col rounded-3xl border border-[var(--line)] bg-[rgba(7,7,7,0.92)] p-3 backdrop-blur-xl md:hidden">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-mobile-${id}`} onClick={() => go(id)}
              className="px-4 py-3 text-left font-display text-2xl uppercase">{label}</button>
          ))}
        </div>
      )}
    </motion.header>
  );
};
